import { BackgroundColors, TextColors } from "@abel-technologies-as/components";
import styled from "styled-components";

export const PictureContainer = styled.div`
	position: relative;
	height: 34px;
`;

export const RestItem = styled.div<{ left: string }>`
	width: 27px;
	border: 1.5px solid ${TextColors.White};
	height: 27px;
	border-radius: 50%;
	position: absolute;
	top: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	transform: translate(-50%, -50%);
	left: ${({ left }) => left};
	background-color: ${BackgroundColors.SecondaryHover};
`;

export const IconWrapper = styled.div`
	margin-right: 5.5px;
`;

export const PictureWrapper = styled.div<{ left: string }>`
	border: 1.5px solid ${TextColors.White};
	position: absolute;
	top: 50%;
	width: 27px;
	height: 27px;
	border-radius: 50%;
	left: ${({ left }) => left};
	transform: translate(-50%, -50%);
`;
